<template>
  <div id="tags-view-container" class="tags-view-container">
    <div class="fui-tabs-control" style="left: 0; margin: auto;border-right: 1px solid #f6f6f6;" @click="rollPage('left')">
      <i class="el-icon-d-arrow-left" /></div>
    <div class="fui-tabs-control" style="right: 0; margin: auto" @click="rollPage()">
      <i class="el-icon-d-arrow-right" /></div>
    <div class="fui-tabs">

      <ul ref="pageTabs" class="fui-tab-title" :style="('left:' + tabLeft + 'px')">
        <router-link
          v-for="tag in visitedViews"
          ref="tag"
          :key="tag.path"
          :class="isActive(tag)?'fui-tab-active':''"
          :to="{path:tag.path,query:tag.query}"
          tag="li"
          class="fui-tab-item"
          @click.middle.native="closeSelectedTag(tag)"
          @contextmenu.prevent.native="openMenu(tag, $event)"
        >
          <span>{{ tag.title }}</span>
          <span v-if="!tag.meta.affix" class="el-icon-close fui-tab-close" @click.prevent.stop="closeSelectedTag(tag)" />
        </router-link>
      </ul>
    </div>
    <ul v-show="visible" ref="contextMenu" :style="postionStyle" class="contextmenu">
      <!-- <li @click="refreshSelectedTag(selectedTag)">
        刷新当前标签页
      </li> -->
      <li v-if="!(selectedTag.meta&&selectedTag.meta.affix)" @click="closeSelectedTag(selectedTag)">
        {{ $t('BaseLayoutTabs.index.2596154-0') }}
      </li>
      <li @click="closeOthersTags">
        {{ $t('BaseLayoutTabs.index.2596154-1') }}
      </li>
    </ul>
  </div>
</template>

<script>
import path from 'path'

export default {
  data() {
    return {
      visible: false,
      tabLeft: 0,
      selectedTag: {},
      affixTags: [],
      postionStyle: {}
    }
  },
  computed: {
    visitedViews() {
      return this.$store.state.tagsView.visitedViews
    },
    routes() {
      return []
    }
  },
  watch: {
    $route() {
      this.addTags()
      this.moveToCurrentTag()
    },
    visible(value) {
      if (value) {
        document.body.addEventListener('click', this.closeMenu)
      } else {
        document.body.removeEventListener('click', this.closeMenu)
      }
    }
  },
  mounted() {
    this.initTags()
    this.addTags()
  },
  methods: {
    isActive(route) {
      return route.path === this.$route.path
    },
    filterAffixTags(routes, basePath = '/') {
      let tags = []
      routes.forEach(route => {
        if (route.meta && route.meta.affix) {
          const tagPath = path.resolve(basePath, route.path)
          tags.push({
            fullPath: tagPath,
            path: tagPath,
            name: route.name,
            meta: {...route.meta}
          })
        }
        if (route.children) {
          const tempTags = this.filterAffixTags(route.children, route.path)
          if (tempTags.length >= 1) {
            tags = [...tags, ...tempTags]
          }
        }
      })
      return tags
    },
    initTags() {
      const affixTags = this.affixTags = this.filterAffixTags(this.routes)
      for (const tag of affixTags) {
        // Must have tag name
        if (tag.name) {
          this.$store.dispatch('tagsView/addVisitedView', tag)
        }
      }
    },
    addTags() {
      const {name} = this.$route
      if (name) {
        this.$store.dispatch('tagsView/addView', this.$route)
      }
      return false
    },
    moveToCurrentTag() {
      const tags = this.$refs.tag
      this.$nextTick(() => {
        let tabIndex = -1
        for (const tag of tags) {
          tabIndex++
          if (tag.to.path === this.$route.path) {
            // when query is different then update
            if (tag.to.fullPath !== this.$route.fullPath) {
              this.$store.dispatch('tagsView/updateVisitedView', this.$route)
            }
            break
          }
        }
        if (tabIndex > -1) {
          this.rollPage('auto', tabIndex)
        }

      })
    },
    // refreshSelectedTag(view) {
    //   this.$store.dispatch('tagsView/delCachedView', view).then(() => {
    //     const {fullPath} = view
    //     this.$nextTick(() => {
    //       this.$router.replace({
    //         path: fullPath,
    //         query: {
    //           t: Date.now()
    //         }
    //       })
    //     })
    //   })
    // },
    closeSelectedTag(view) {
      if (this.visitedViews.length === 1) {
        this.$message({
          message: this.$t('BaseLayoutTabs.index.2596154-2'),
          type: 'warning'
        })
        return
      }
      view.meta.keepAlive = false
      this.$store.dispatch('tagsView/delView', view).then(({visitedViews}) => {
        if (this.isActive(view)) {
          this.toLastView(visitedViews)
        }
      })
    },
    closeOthersTags() {
      this.$router.push(this.selectedTag)
      this.$store.dispatch('tagsView/delOthersViews', this.selectedTag).then(() => {
        this.moveToCurrentTag()
      })
    },
    closeAllTags(view) {
      this.$store.dispatch('tagsView/delAllViews').then(({visitedViews}) => {
        if (this.affixTags.some(tag => tag.path === view.path)) {
          return
        }
        this.toLastView(visitedViews)
      })
    },
    toLastView(visitedViews) {
      const latestView = visitedViews.slice(-1)[0]
      if (latestView) {
        this.$router.push(latestView)
      } else {
        // You can set another route
        this.$router.push('/')
      }
    },
    openMenu(tag, e) {
      const menuMinWidth = 160
      const maxLeft = screen.width - menuMinWidth // left boundary
      const left = e.clientX + 15 // 15: margin right

      // 找到对应的tab标签
      // let tabIndex = -1
      // for (const tagItem of this.$refs.tag) {
      //   tabIndex++
      //   if (tag.to.path === tagItem.to.path) {
      //     break
      //   }
      // }
      // this.left = left
      if (left > maxLeft) {
        this.postionStyle = {
          top: e.clientY + 'px',
          right: (screen.width - left) + 'px'
        }
      } else {
        this.postionStyle = {
          top: e.clientY + 'px',
          left: left + 'px'
        }
      }
      this.visible = true
      this.selectedTag = tag
    },
    closeMenu() {
      this.visible = false
    },
    rollPage(type, index) {
      let tabsHeader = this.$refs.pageTabs
      let liItem = tabsHeader.children
      let outerWidth = tabsHeader.offsetWidth
      let tabsLeft = parseFloat(tabsHeader.style.left === '' ? 0 : tabsHeader.style.left)

      // 右左往右
      if (type === 'left') {
        if (!tabsLeft && tabsLeft <= 0) return

        // 当前的left减去可视宽度，用于与上一轮的页标比较
        let prefLeft = -tabsLeft - outerWidth

        let i
        for (i = 0; i < liItem.length; i++) {
          let li = liItem[i]
          let left = li.offsetLeft

          if (left >= prefLeft) {
            this.tabLeft = -left
            return false
          }
        }
      } else if (type === 'auto') { // 自动滚动

        let thisLi = liItem[index]
        let thisLeft

        if (!thisLi) return
        thisLeft = (thisLi.offsetLeft === '' ? 0 : thisLi.offsetLeft)

        // 当目标标签在可视区域左侧时
        if (thisLeft < -tabsLeft) {
          this.tabLeft = -thisLeft
          return
        }

        // 当目标标签在可视区域右侧时
        if (thisLeft + thisLi.offsetWidth >= outerWidth - tabsLeft) {
          let subLeft = thisLeft + thisLi.offsetWidth - (outerWidth - tabsLeft)
          let i
          for (i = 0; i < liItem.length; i++) {
            let li = liItem[i]
            let left = li.offsetLeft

            // 从当前可视区域的最左第二个节点遍历，如果减去最左节点的差 > 目标在右侧不可见的宽度，则将该节点放置可视区域最左
            if (left + tabsLeft > 0) {
              if (left - tabsLeft > subLeft) {
                this.tabLeft = -left
                return false
              }
            }
          }
        }
      } else {
        // 默认向左滚动
        let i
        for (i = 0; i < liItem.length; i++) {
          let li = liItem[i]
          let left = li.offsetLeft

          if (left + li.offsetWidth >= outerWidth - tabsLeft) {
            this.tabLeft = -left
            return false
          }
        }
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/config/styles/variables.scss";
  .tags-view-container {
    position: relative;
    padding: 0 40px 0 40px;
    height: $tabsHeight;
    overflow:hidden;
    background: #fff;
    border-bottom: 1px solid #d8dce5;
    box-shadow: 0 1px 3px 0 rgba(0, 0, 0, .12), 0 0 3px 0 rgba(0, 0, 0, .04);

    .tags-view-wrapper {
      .tags-view-item {
        min-width: 0;
        height: 40px;
        line-height: 40px;
        max-width: 160px;
        text-overflow: ellipsis;
        padding-right: 40px;
        overflow: hidden;
        border-right: 1px solid #f6f6f6;
        vertical-align: top;
        cursor: pointer;
        /*display: inline-block;*/
        /*position: relative;*/
        /*cursor: pointer;*/
        /*height: 40px;*/
        /*line-height: 40px;*/
        /*color: #495060;*/
        /*background: #fff;*/
        /*padding: 0 8px;*/
        /*font-size: 14px;*/
        /*margin-left: 5px;*/
        /*margin-top: 3px;*/
        &:first-of-type {
          margin-left: 15px;
        }

        &:last-of-type {
          margin-right: 15px;
        }

        &.active {
          /*background-color: #42b983;*/
          /*color: #fff;*/
          color: #1890ff;
          border-color: #1890ff;
          border-bottom: 2px solid;

          &::before {
            content: '';
            background: #1890ff;
            display: inline-block;
            width: 8px;
            height: 8px;
            border-radius: 50%;
            position: relative;
            margin-right: 2px;
          }
        }

        &:focus, &:hover {
          color: #1890ff;
        }
      }
    }

    .contextmenu {
      margin: 0;
      background: #fff;
      z-index: 1000;
      position: fixed;
      list-style-type: none;
      padding: 5px 0;
      border-radius: 4px;
      font-size: 14px;
      font-weight: 400;
      color: #333;
      box-shadow: 2px 2px 3px 1px rgba(0, 0, 0, .3);

      li {
        margin: 0;
        padding: 7px 16px;
        cursor: pointer;

        &:hover {
          background: #eee;
        }
      }
    }

    & > .fui-tabs-control {
      position: absolute;
      top: 0;
      width: 40px;
      height: 100%;
      text-align: center;
      cursor: pointer;
      /*transition: all .3s;*/
      /*-webkit-transition: all .3s;*/
      box-sizing: border-box;
      border-left: 1px solid #f6f6f6;
      font-size: 20px;

      &:hover {
        background-color: #f6f6f6;
      }

      & > i {
        position: relative;
        top: 50%;
        transform: translate(0%, -50%);
      }
    }

    & > .fui-tabs {
      margin: 0;
      overflow: hidden;
      & > .fui-tab-title {
        height: 40px;
        border: none;
        position: relative;
        left: 0;
        white-space: nowrap;
        font-size: 0;
        transition: all .5s;
        -webkit-transition: all .5s;
        padding-left: 0;
        & > .fui-tab-item {
          min-width: 0;
          line-height: 40px;
          max-width: 160px;
          text-overflow: ellipsis;
          padding-right: 30px;
          padding-left: 15px;
          overflow: hidden;
          border-right: 1px solid #f6f6f6;
          vertical-align: top;
          display: inline-block;
          *display: inline;
          *zoom: 1;
          font-size: 14px;
          transition: all .2s;
          -webkit-transition: all .2s;
          position: relative;
          text-align: center;
          cursor: pointer;
          list-style: none;
          color: #666;
          & > .fui-tab-close {
            position: absolute;
            right: 8px;
            top: 50%;
            margin: -7px 0 0 0;
            width: 16px;
            height: 16px;
            line-height: 16px;
            border-radius: 50%;
            font-size: 12px;
            display: inline-block;
            text-align: center;
            color: #c2c2c2;
            transition: all .3s;
            -webkit-transition: all .3s;
            &:hover {
              background: #409EFF;
            }
          }
          &:hover {
            color: #000;
            background: #f6f6f6;
            &::after {
              width: 100%;
            }
          }
        }

        .fui-tab-active {
          color: #000;
          background: #f6f6f6;
          &::after {
            width: 100%;
          }
        }
        li::after {
          position: absolute;
          left: 0;
          top: 38px;
          content: '';
          width: 0;
          border: none;
          height: 2px;
          border-radius: 2px 2px 0 0;
          box-sizing: border-box;
          pointer-events: none;
          background-color: #409EFF;
          transition: all .3s;
          -webkit-transition: all .3s;
        }
      }
    }
  }
</style>

<style lang="scss">
  //reset element css of el-Icon-close
  .tags-view-wrapper {
    .tags-view-item {
      .el-icon-close {
        width: 16px;
        height: 16px;
        vertical-align: 2px;
        border-radius: 50%;
        text-align: center;
        transition: all .3s cubic-bezier(.645, .045, .355, 1);
        transform-origin: 100% 50%;
        color: #fff;

        &:before {
          transform: scale(.6);
          display: inline-block;
          vertical-align: -3px;
        }

        &:hover {
          background-color: #b4bccc;
          color: #fff;
        }
      }

      &:hover {
        .el-icon-close {
          color: #1890ff
        }
      }

    }
  }
</style>
